import {on, select, appendHtml, addClass, removeClass, hasClass} from 'modules/dom'

const ACTIVE_CLASS = 'filters__desktop--active'
const setCurrentText = (selectedElement, newValue) => {
  appendHtml(selectedElement, newValue)
}

export default function (el) {
  const selectMobile = select('select', el)
  const selectCurrent = select('.filters__current', el)
  const filterCurrent = select('.js-filter-current', el)
  const filterDesktop = select('.js-filters-desktop', el)

  const toggleClass = () => {
    if (hasClass(ACTIVE_CLASS, filterDesktop)) {
      removeClass(ACTIVE_CLASS, filterDesktop)
    } else {
      addClass(ACTIVE_CLASS, filterDesktop)
    }
  }

  on('change', function () {
    window.location = selectMobile.value
  }, selectMobile)
  const getCurrentText = (value) => select('option[value="' + value + '"]', selectMobile).text
  const currentText = getCurrentText(selectMobile.value)
  setCurrentText(selectCurrent, '<span>' + currentText + '</span>')

  if (filterCurrent) {
    on('click', () => {
      toggleClass()
    }, filterCurrent)

    on('click', (e) => {
      if (e.target !== filterCurrent && e.target !== filterDesktop) {
        removeClass(ACTIVE_CLASS, filterDesktop)
      }
    }, document)
  }
}
